import React, { useEffect } from "react";
import "./Resources.css";
import { Box, Stack, Typography, AspectRatio } from "@mui/joy";
import LearnTheProcess from "./LearnTheProcess";
import FrequentlyAskedQuestions from "./TakeActions";
import TypesOfLegislation from "./TypesOfLegislation";
import SEOHead from "../../components/SEOHead/SEOHead";
import seoConfig from "../../utils/seoConfig";
import WashingtonImg from "../../jacob-creswick-ra3oAd6hrnM-unsplash.jpg";

function Resources() {
  useEffect(() => {
    document.title = seoConfig.pages.resources.title;
  }, []);

  return (
    <>
      <SEOHead
        title={seoConfig.pages.resources.title}
        description={seoConfig.pages.resources.description}
        keywords={seoConfig.pages.resources.keywords}
        path={seoConfig.pages.resources.path}
        structuredData={[seoConfig.getBreadcrumbs("/resources", "Resources")]}
      />
      <Box sx={{ minHeight: "100vh" }}>

        {/* ── HERO ── */}
        <Box
          sx={{
            position: "relative",
            backgroundColor: "#003049",
            backgroundImage: `linear-gradient(rgba(0,48,73,0.72), rgba(0,48,73,0.72)), url(${WashingtonImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center 35%",
          }}
        >
          <Box
            sx={{
              maxWidth: "1200px",
              mx: "auto",
              px: { xs: "1.25rem", md: "2rem" },
              py: { xs: "3rem", md: "4.5rem" },
            }}
          >
            <Stack
              direction={{ xs: "column", lg: "row" }}
              spacing={{ xs: 4, lg: 8 }}
              alignItems={{ xs: "flex-start", lg: "center" }}
            >
              {/* Text */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  component="p"
                  sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fdf0d5",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    mb: "16px",
                  }}
                >
                  Civic Education
                </Typography>
                <Typography
                  level="h1"
                  sx={{
                    color: "white",
                    fontSize: { xs: "2.25rem", md: "3.5rem" },
                    fontWeight: 700,
                    lineHeight: 1.15,
                    mb: "20px",
                  }}
                >
                  Get Informed.
                  <br />
                  Take Action.
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontSize: "1.125rem",
                    lineHeight: 1.65,
                    maxWidth: "500px",
                  }}
                >
                  Understand how laws are made, what types of legislation exist,
                  and how to make your voice heard — all in one place.
                </Typography>
              </Box>

              {/* Video embed */}
              <Box sx={{ width: { xs: "100%", lg: "480px" }, flexShrink: 0 }}>
                <AspectRatio
                  ratio="16/9"
                  sx={{
                    borderRadius: "4px",
                    overflow: "hidden",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
                  }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/men-vp5jvzI?si=M1LsYPh7A05lnMsU"
                    title="Schoolhouse Rock: How a Bill Becomes a Law"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </AspectRatio>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.4)",
                    mt: "10px",
                  }}
                >
                  Schoolhouse Rock: How a Bill Becomes a Law · 4 min
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Box>

        {/* ── CONTENT SECTIONS ── */}
        <Box sx={{ backgroundColor: "#f8fafc" }}>
          <LearnTheProcess />
          <TypesOfLegislation />
          <FrequentlyAskedQuestions />
        </Box>

      </Box>
    </>
  );
}

export default Resources;
